// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_6wc","cls2":"ResearchExamples-cls2_Pho ResearchExamples-cls1_6wc"};